/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("polyfills/fetch");
var classListPolyfill = require("polyfills/classList");

import baustein from "baustein";
import analytics from "analytics/analytics";
import requester from "modules/requester";
import overlayMixin from "components/mixins/overlay-mixin";

export default baustein.register("generic-overlay", {
    mixins: [overlayMixin],

    defaultOptions: {
        contentUrl: null,
        overlaySize: "large",
        eventCategory: null,
        eventAction: null,
        eventLabel: null
    },

    getOverlayContent() {
        const options = {
            headers: {
                Accept: "text/html"
            }
        };
        return requester(this.options.contentUrl, options).then(requester.toText);
    },

    onOverlayOpen() {
        if (this.options.eventCategory && this.options.eventAction) {
            const { eventCategory, eventAction, eventLabel } = this.options;
            analytics.event(eventCategory, eventAction, eventLabel);
        }
    },

    onOverlayCloseIntent() {
        this.close();
    }
});

